module.exports = __webpack_public_path__ + "img/bn.svg";